import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    Routes,
    RouterModule
} from '@angular/router';

import { HomeComponent } from './public/home/home.component';
import { ServicesComponent } from './public/services/services.component';
import { ContactComponent } from './public/contact/contact.component';
import { NotFoundComponent } from './public/not-found/not-found.component';

const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'services', component: ServicesComponent },
    { path: 'contact', component: ContactComponent },
    { path: '**', component: NotFoundComponent } // 404 Error
];

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'reload',
            scrollPositionRestoration: 'enabled'
        })
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
